<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>

      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import iPayPaymentCode from "@/components/Param/iPayPaymentCode"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"


let invoiceNumTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  if(dataItem['jt-summary']) return;
  
  let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
  return `<a href="billPage?invoiceID=${dataItem.id}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
  // return `<a href="${dataItem.path}" target="_blank">${billNum}</a>`;
};
let invoiceAmountTableCustom = function(dataResult, dataIndex, dataParameter, parameterIndex) {
  let parameterItem = dataParameter[parameterIndex];
  let dataItem = dataResult[dataIndex];
  return helper.formatMoney(dataItem[parameterItem.key]);
};

var querystring = require('querystring');
const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'id',
    text: 'Ref. No.',
  },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: '_licenseNum',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem['licenseID']) {
        return;
      }
      if(dataItem['_licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['_licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: '_customerAccount',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex]['_customer'];
      if(!dataItem.id) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.id}">${dataItem.name}</a><br>${dataItem.nationalID}`;
      }
    },
  },
  {
    key: 'status',
    text: 'Status',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem) return '';
      return helper.convertPaymentStatus(dataItem['status']);
    }
  },
  {
    key: '_amount',
    text: 'Amount (RM)',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      let total = 0;
      if(dataItem['_invoice'] && dataItem['_invoice'].length > 0) {
        dataItem['_invoice'].forEach(k => {
          if(k.type.endsWith('CN')) {
            total -= k.price
          } else {
            total += k.price
          }
        })
      }
      return helper.formatMoney(total);
    }
  },
  {
    key: 'paymentType',
    text: 'Payment Method',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem) return '';

      let text;
      if(dataItem['paymentName']) {
        text = 'Online (' +  dataItem['paymentName'] + ')';
        
      } else {
        text = helper.convertPaymentMethod(dataItem['paymentType']);
      }
      // if(dataItem['paymentiPay']) {
      //   text += '<br>' + dataItem['paymentiPay'];
      // }
      return text;
    }
  },
  {
    key: '_updatedDate',
    text: 'Date Updated',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem) return '';

      let collectionDate = dataItem['collectionDate'];
      if(collectionDate) {
        return helper.formatDateTime(collectionDate);
      }
      return helper.formatDateTime(dataItem['createDate']);
    }
  },
  {
    key: '_bill',
    text: 'Bills',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];

      return `<a target="_blank" href="${helper.WEB_URL}/payDetail?collectionID=${dataItem.id}">Bills</a>`;

      let temp = '';
      if(dataItem['_invoice'] && dataItem['_invoice'].length > 0) {
        dataItem['_invoice'].forEach(k => {
          temp += '<a href="">';
          let dataItem = k;
          let billNum = helper.plBillNum(dataItem.creditNum || dataItem.debitNum || dataItem.invoiceNum, dataItem.carparkID, dataItem['type']);
          temp += `<a href="billPage?invoiceID=${dataItem.invoiceID}&type=${dataItem._type}" target="_blank">${billNum}</a>`;
          temp += '</a>';
          temp += '<br>';
        });
      }
      return temp;
    }
  },
];

export default {
  name: "PagePaymentHistory",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Bill Collection' },
        { name: 'Transaction' },
        { name: 'Payment History' },
      ],

      PARAM,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }
      
      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;

          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          // // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.loadCustomer();
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });

          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);
          // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadData();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadData() {
      let feedbackItem = 'payment history';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/collection?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          response.data = response.data.filter(k => {
            if(this.$refs['carparkFilter'].filterValue) {
              if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
                return false;
              }
            }
            if(this.$refs['licenseFilter'].filterValue) {
              let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
              if(!helper.compareID(k.customerID, license.customerID)) {
                return false;
              }
            }
            return true;
          });
          
          let temp = {};
          response.data.forEach(k => {
            let type = k['type'];
            if(type.endsWith('INV')) {
              k['_type'] = 'invoice';
            } else if(type.endsWith('CN')) {
              k['_type'] = 'creditNote';
            } else if(type.endsWith('DN')) {
              k['_type'] = 'debitNote';
            }

            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);
            } catch(e) {              
            }

            k['_license'] = this.pageLicense.find(j => j.carparkID === k.carparkID && j.customerID === k.customerID);
            k['licenseID'] = k['_license']['id'];
            k['_licenseStatus'] = k['_license']['status'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum'];
            k['_carparkNum'] = k['_license']['carparkID'];
            k['_carpark'] = this.pageCarpark.find(j => j.id === k['carparkID']) || {};
            k['_carparkName'] = (k['_carpark'] || {}).name;
            k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']) || {};
            k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';

            let collectionID = k['id'];
            temp[collectionID] = temp[collectionID] || k;
            temp[collectionID]._invoice = temp[collectionID]._invoice || [];
            temp[collectionID]._invoice.push(k);
          });

          this.pageCollection = Object.keys(temp).map(k => temp[k]);
          // this.pageCollection = this.pageCollection.sort((a,b) => b.createDate - a.createDate);

          this.loadFund();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadFund() {
      let feedbackItem = 'payment history detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/fund/online';

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          this.pageFund = response.data;

          this.loadCollectionGroup();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCollectionGroup() {
      let feedbackItem = 'payment history collection';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/collection?sort=createDate&group=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID;
      }
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          response.data = response.data.filter(k => {
            if(this.$refs['carparkFilter'].filterValue) {
              if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
                return false;
              }
            }
            if(this.$refs['licenseFilter'].filterValue) {
              let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
              if(!helper.compareID(k.customerID, license.customerID)) {
                return false;
              }
            }
            return true;
          });

          this.pageCollectionGroup = response.data;

          this.processData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },


    processData() {
      this.pageCollectionGroup.forEach(k => {
        if(k.paymentType === 'online' || k.paymentType === 'Online') {
          let paymentInfo = this.pageFund.find(j => helper.compareID(j.RefNo, k.id))
          if(paymentInfo) {
            k['paymentiPay'] = paymentInfo.TransId

            let paymentMethod = iPayPaymentCode.find(j => helper.compareID(j.paymentId, paymentInfo['PaymentId']));
            if(paymentMethod && paymentMethod.paymentMethod) {
              k['paymentName'] = paymentMethod.paymentMethod
            }
          }
        }
        let matchingCollection = this.pageCollection.find(j => j.id === k.id);
        if(matchingCollection) {
          for(let key of Object.keys(matchingCollection)) {
            k[key] = matchingCollection[key];
          }
        }
      });

      this.$refs['pageTable'].setTableData(this.pageCollectionGroup);
    },

    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(null);
      this.loadData();
    },
    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },

    onFormInput(formData, formParameter, input) {
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PagePaymentHistory.vue